export default __webpack_public_path__ + "static/media/panther-busd.716ed313.png";